export default __webpack_public_path__ + "static/Klick-Bold-dded47d8fd8e4e01b25c3d4dcb4f8f6d.woff2";